import type { FunctionComponent } from 'react';
import { CardGroup } from '@george-labs.com/design-system';

import { DevToolsCard } from '../DevToolsCard';
import { FeatureToggleForm } from './FeatureToggleForm';

export const FeatureToggleCard: FunctionComponent = () => (
    <CardGroup noGap className="mt-0 rounded-0">
        <DevToolsCard title="Feature toggle">
            <FeatureToggleForm />
        </DevToolsCard>
    </CardGroup>
);
